/**home But**/
<template>
  <div class="homeBut" v-if="hideState">
<!--    {{urlFns}}-->
    <img src="../../../../assets/img/yonghu/huome.png" @click="imgButFn()">
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'xk-homeBut',
    computed: {
      ...mapGetters({
        servesTypeNav: 'servesTypeNav'
      })
    },
    data () {
      return {
        hideState: true
      }
    },
    methods: {
      imgButFn: function () {
        // this.$router.push(this.servesTypeNav[0].url)
        this.$router.push('/')
      }
    },
    watch: {
      '$route': {
        handler (val) {
          // let fullPath = this.$route.path
          if (this.$route.path === '/' || this.$route.path === '/daijia' || this.$route.path === '/login' || val.fullPath.indexOf('/settlement') >= 0) { // 首页，登陆页，支付页，不显示回到首页的按钮
            this.hideState = false
          } else {
            this.hideState = true
          }
        },
        deep: true,
        immediate: true
      }
    },
    mounted: function () {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .homeBut {
    position: fixed;
    left: 0;
    padding-right: 1rem;
    top: 3rem;
    z-index: 250;
    transition: 0.3s all;

    img {
      width: 2.5rem;
    }
  }

  .homeButShow {
    padding-right: 0;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// homeBut.vue?936a8a0a